import { Pipe, PipeTransform } from '@angular/core';

import { SelectedOption } from '../model/selected-option';

@Pipe({
    name: 'sortCustomOptions'
})

export class SortCustomOptionsPipe implements PipeTransform {
    transform(value: Array<SelectedOption>) {
        if (value !== undefined && value !== null && value.length > 1) {
            return value.sort((leftHand, rightHand) => this.compareSelectedOptions(leftHand, rightHand));
        }
        return value;
    }

    /**
     * Compares two SelectedOptions based on: FrequencySequenceNumber ascending, then OptionNumber ascending, then OptionDesc alphabetically
     * 
     * Items with FrequencySequenceNumber !== 0 are before items with FrequencySequenceNumber === 0; ditto for OptionNumber
     */
    private compareSelectedOptions(leftHand: SelectedOption, rightHand: SelectedOption): number {
        return (
            this.compareTruthyValues(leftHand.FrequencySequenceNumber, rightHand.FrequencySequenceNumber, this.compareNumbers) ||
            this.compareTruthyValues(+(leftHand.OptionNumber), +(rightHand.OptionNumber), this.compareNumbers) ||
            this.compareTruthyValues(leftHand.OptionDesc, rightHand.OptionDesc, this.compareStrings)
        );
    }

    /**
     * Evaluates the comparator if both sides are truthy.
     * If only one side is truthy, declare that side to come first.
     * If both sides are falsy, declare them equal.
     */
    private compareTruthyValues(leftHand: any, rightHand: any, comparator: (leftHand: any, rightHand: any) => number): number {
        if(leftHand) {
            return rightHand ? comparator(leftHand, rightHand) : -1;
        }

        return rightHand ? 1 : 0;
    }

    private compareNumbers(leftHand: number, rightHand: number): number {
        return leftHand - rightHand;
    }

    private compareStrings(leftHand: string, rightHand: string): number {
        return leftHand.localeCompare(rightHand)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/sort-custom-options.pipe.ts